module.exports = __webpack_public_path__ + "static/media/pptx.68d8c1ce.png";